import { navigateMediaItem } from "@/helpers/navigateMediaItem.js";
import { headerLine } from '@/modules/parts/headerLine';
import { ctaButton } from "@/modules/parts/ctaButton";
import { mobileMenuArea } from "@/modules/parts/mobile/mobileMenuArea";
import { closeSwipeAction } from '@/modules/actions/mobile/closeSwipeAction';
import { volumeButtonClickAction } from '@/modules/actions/volumeButtonClickAction';
import { closeButtonClickAction } from '@/modules/actions/closeButtonClickAction';
import { sharingClickAction } from '@/modules/actions/sharingClickAction';
import { desktopMenuArea } from "@/modules/parts/desktop/desktopMenuArea";
import { mobileVideoControls, activeVideoPlay } from "@/modules/actions/videoControls";
import { desktopArrowIcons } from "@/modules/parts/desktop/desktopArrowIcons";
import { preloadVideo } from "@/helpers/preloadVideo";
import { playEventHandler } from "@/helpers/playEventHandler";
import { trackMediaProcess } from "@/helpers/trackMediaProcess";
import { createSlide } from '@/modules/createSlide';
import initSwiper from "@/plugins/initSwiper";
import { getSwiperInstance } from "@/helpers/swiperInstance";
import { desktopArrowIconsAction } from '@/modules/actions/desktop/desktopArrowIconsAction';
import { groupMoveButton } from '@/modules/parts/desktop/groupMoveButton';
import { applySlideScaling } from "@/modules/actions/slideScaleAction";
import { updateHeaderWidthToSlide } from "@/modules/actions/updateHeaderWidthAction";
import { groupMoveButtonAction } from '@/modules/actions/desktop/groupMoveButtonAction';
import { clickCtaAction } from '@/modules/actions/clickCtaAction';
import { setupAutoPlayNextAction } from '@/modules/actions/desktop/setupAutoPlayNextAction';
import { injectHeaderLineStyles } from '@/modules/actions/headerLineDuration.js';
import { slideClickNavigateAction } from "@/modules/actions/desktop/slideClickNavigateAction";
import { changeMovieTapAction } from "@/modules/actions/mobile/changeMovieTapAction";
import { groupSwipeAction } from "@/modules/actions/mobile/groupSwipeAction";
import { swipeCtaAction } from "@/modules/actions/mobile/swipeCtaAction";
import { mobileAutoPlayNextAction } from "@/modules/actions/mobile/mobileAutoPlayNextAction";
import { visibilityChangeAction } from "@/modules/actions/visibilityChangeAction";
import { preventFullscreen } from '@/modules/actions/preventFullscreen';
import { introSquareSlideAnimation } from '@/modules/actions/mobile/introSquareSlideAnimation';
import { circleOverlayAction } from '@/modules/actions/mobile/circleOverlayAction';

export const setupVideoPlayerModal = () => {
  // PC表示時のみ、前後スライドにグレーのオーバーレイを追加
  if (!window.storeeelItems.isMobile) {
    const overlayStyle = document.createElement('style');
    overlayStyle.textContent = `
      .storeeel-swiper-group-wrapper .swiper-slide-prev::after,
      .storeeel-swiper-group-wrapper .swiper-slide-next::after {
        content: '';
        position: absolute;
        top: 0; left: 0;
        width: 100%; height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        pointer-events: none;
        border-radius: 30px;
        z-index:10000;
      }
    `;
    document.head.appendChild(overlayStyle);
  }

  // 不要な余白を削除
  // SP時のみ storeeelSwiper 内の swiper-wrapper に margin:0!important を適用
  if (window.storeeelItems.isMobile) {
    const mobileStyle = document.createElement('style');
    mobileStyle.textContent = `
      .storeeelSwiper .swiper-wrapper {
        margin: 0 !important;
      }
    `;
    document.head.appendChild(mobileStyle);
  }
  // 全画面にモーダルを表示
  const modal = document.createElement('div');
  modal.style.position = 'fixed';
  modal.style.top = '0';
  modal.style.left = '0';
  modal.style.width = '100%';
  modal.style.height = '100%'; // 画面の高さを100%に設定
  modal.style.zIndex = '9999999999'; // 他の要素より前面に表示
  modal.style.backgroundColor = 'var(--Black-90, rgba(39, 39, 39, 0.90))'; // 背景色を黒に設定
  modal.style.backdropFilter = 'blur(50px)';
  modal.className = 'storeeel-modal';
  modal.style.transform = 'translateY(-100%)'; // 初期状態で画面外
  modal.style.transition = 'opacity 0.5s, transform 0.5s'; // アニメーションの設定
  document.body.style.overflow = 'hidden';

  document.body.appendChild(modal);
  // iPhone のときのみ、モーダル内の全動画で全画面抑制を再バインド
  if (window.isIphone) {
    modal.querySelectorAll('video').forEach(videoEl => preventFullscreen(videoEl));
  }

  setTimeout(() => {
    modal.style.opacity = '1';
    modal.style.transform = 'translateY(0)';
  }, 10);

  // PCかつ、square以外はグループ内のコンテンツを取得
  const contents = (!window.storeeelItems.isMobile && window.storeeelItems.frame === 'square')
  ? []
  : navigateMediaItem();

  // swiperのスライドを生成
  function setupSwiperGroup() {
    const groupWrapper = document.createElement('div');
    groupWrapper.className = 'storeeel-swiper-group-wrapper';

    const swiperContainer = document.createElement('div');
    swiperContainer.className = 'storeeel-swiper-container';

    const swiperElement = document.createElement('div');
    swiperElement.className = 'swiper storeeelSwiper';
    swiperElement.style.inset = '0';
    swiperElement.style.margin = '0';
    swiperElement.style.padding = '0';

    // 外部テーマからの.swiper干渉を防ぐ最低限リセット（レイアウト系のみ）
    const isolationStyle = document.createElement('style');
    isolationStyle.textContent = `
      .storeeel-swiper-group-wrapper .swiper.storeeelSwiper {
        margin: 0 !important;
        padding: 0 !important;
        inset: 0 !important;
        box-sizing: border-box !important;
        position: relative !important;
        display: flex !important;
        width: 100% !important;
        height: 100% !important;
        overflow: hidden !important;
      }

      .storeeel-swiper-group-wrapper .swiper.storeeelSwiper .swiper-wrapper {
        display: flex !important;
        transition-property: transform !important;
        box-sizing: content-box !important;
      }

      .storeeel-swiper-group-wrapper .swiper.storeeelSwiper .swiper-slide {
        flex-shrink: 0 !important;
        position: relative !important;
        transition-property: transform !important;
      }
    `;
    document.head.appendChild(isolationStyle);

    swiperContainer.appendChild(swiperElement);

    const wrapper = document.createElement('div');
    wrapper.className = 'swiper-wrapper';
    // モバイルかつ circle ではない場合のみ、wrapper の高さを 100dvh に固定
    if (window.storeeelItems.isMobile && window.storeeelItems.frame !== 'circle') {
      wrapper.style.height = '100dvh';
    }

    // デバイスと表示方法によってswiperのグループ化の処理を変える
    if (window.storeeelItems.isMobile) {
      // モバイル
      if (window.storeeelItems.frame === 'circle') {
        // circle時のみグループごとの最初の動画を使う
        const groups = window.storeeelItems.contentGroups || [];
        groups.forEach(group => {
          const firstContent = group.contents?.[0];
          if (firstContent) {
            wrapper.appendChild(createSlide(firstContent));
          }
        });
      } else {
        // SP + square: 全てのグループの最初の動画を順序どおりに追加
        const groups = window.storeeelItems.contentGroups || [];
        groups.forEach(group => {
          const firstContent = group.contents?.[0];
          if (firstContent) {
            wrapper.appendChild(createSlide(firstContent));
          }
        });
      }
    } else {
      // PC
      // circleの場合は、選択したグループ内のコンテンツを全てswiperに追加
      if (window.storeeelItems.frame === 'circle') {
        contents.forEach(content => {
          wrapper.appendChild(createSlide(content));
        });
      } else {
        // squareの場合は、全てのコンテンツをswiperに追加
        const allContents = window.storeeelItems.contentGroups.flatMap(group => group.contents);
        allContents.forEach(content => {
          wrapper.appendChild(createSlide(content));
        })
      }
    }

    swiperElement.appendChild(wrapper);
    groupWrapper.appendChild(swiperContainer);

    return groupWrapper;
  }

  // Swiper の DOM を生成
  const groupWrapperNode = setupSwiperGroup(contents);
  modal.appendChild(groupWrapperNode);
  // PC 時のみ矢印アイコンを swiper-wrapper 内に挿入
  if (!window.storeeelItems.isMobile) {
    const wrapper = modal.querySelector('.storeeel-swiper-group-wrapper');
    if (wrapper) {
      wrapper.insertAdjacentHTML('beforeend', desktopArrowIcons());
    }
  }
  // 2025-05-03: PC時のみ swiper-group-wrapper を中央に固定配置
  if (!window.storeeelItems.isMobile) {
    groupWrapperNode.style.position = 'fixed';
    groupWrapperNode.style.top = '54%';
    groupWrapperNode.style.left = '50%';
    groupWrapperNode.style.transform = 'translate(-50%, -50%)';
    groupWrapperNode.style.maxWidth = '1150px';
    groupWrapperNode.style.width = '63%';
    groupWrapperNode.style.minWidth = '700px';
    groupWrapperNode.style.zIndex = '100';
  }

  // 動画進捗バーの生成
  function setupProgressBar() {
    if (window.storeeelItems.isMobile) {
      // モバイル
      const allSlides = document.querySelectorAll('.storeeel-swiper-group-wrapper .swiper-slide');

      if (window.storeeelItems.frame === "circle") {
        const groups = window.storeeelItems.contentGroups || [];

        allSlides.forEach((slide, index) => {
          const group = groups[index];
          const count = group?.contents?.length || 0;
          const groupName = group?.name || '';
          const headerWrapper = document.createElement('div');
          headerWrapper.innerHTML = headerLine(count, groupName);
          slide.prepend(headerWrapper.firstElementChild);
        });
      } else {
        // 通常SP（circleでない）
        allSlides.forEach((slide, index) => {
          const content = contents[index];
          const groupName = content?.group_name || '';
          const headerWrapper = document.createElement('div');
          headerWrapper.innerHTML = headerLine(contents.length, groupName);
          slide.prepend(headerWrapper.firstElementChild);
        });
      }
    } else {
      // PC
      if (window.storeeelItems.frame === 'circle') {
        const firstIdx = window.moviePosition || 0;
        const firstGroupName =
          contents?.[firstIdx]?.group_name ||
          window.storeeelItems.contentGroups?.[firstIdx]?.name ||
          '';
        const headerLineWrapper = document.createElement('div');
        headerLineWrapper.innerHTML = headerLine(contents.length, firstGroupName);
        const swiperGroupWrapper = modal.querySelector('.storeeel-swiper-group-wrapper');
        if (swiperGroupWrapper) {
          swiperGroupWrapper.appendChild(headerLineWrapper.firstElementChild);
        }
      } else {
        const headerLineWrapper = document.createElement('div');
        headerLineWrapper.innerHTML = headerLine(1);
        const swiperGroupWrapper = modal.querySelector('.storeeel-swiper-group-wrapper');
        if (swiperGroupWrapper) {
          swiperGroupWrapper.appendChild(headerLineWrapper.firstElementChild);
        }
      }
    }

    if (window.storeeelItems.isMobile) {
      injectHeaderLineStyles();
    }
  }
  setupProgressBar();

  // メニューエリアの生成
  function setupMenuArea() {
    if (window.storeeelItems.isMobile) {
      modal.insertAdjacentHTML('beforeend', mobileMenuArea());
    } else {
      if (window.storeeelItems.frame === "circle") {
        // 左右下のグループ移動ボタン
        modal.insertAdjacentHTML('beforeend', groupMoveButton());
      }
      modal.insertAdjacentHTML('beforeend', desktopMenuArea());
    }
  }
  setupMenuArea();

  // —— DOM 完成後に Swiper 初期化 ——
  if (window.storeeelItems.isMobile) {
    // SP＋circle の場合
    if (window.storeeelItems.frame === 'circle') {
      const idx = window.storeeelItems.contentGroups.findIndex(
        ({ id }) => id == window.iconId
      );
      if (idx !== -1) {
        initSwiper({ initialSlide: idx });
      }
    } else {
      // SP＋square の場合: クリックしたグループのスライドを初期表示
      const idx = window.storeeelItems.contentGroups.findIndex(
        ({ id }) => id == window.iconId
      );
      initSwiper({ initialSlide: idx !== -1 ? idx : 0 });
    }
    // --- 初回表示時のプログレスバー制御 (デバッグ付) ---
    const activeSlide = document.querySelector('.storeeel-swiper-group-wrapper .swiper-slide-active');
    if (activeSlide) {
      const activeBanner = activeSlide.querySelector('.storeeel-movie-select_banner');
      const activeVideo  = activeSlide.querySelector('video');
      const activeImage = activeSlide.querySelector('img');
      if (activeBanner && activeVideo) {
        const applyBanner = () => {
          activeBanner.style.setProperty('--duration', `${activeVideo.duration || 3}s`);
          activeBanner.classList.add('active');
        };
        if (activeVideo.readyState >= 1) {
          applyBanner();
        } else {
          activeVideo.addEventListener('loadedmetadata', () => {
            applyBanner();
          }, { once: true });
        }
      } else if (activeImage) {
        const applyBanner = (duration) => {
          activeBanner.style.setProperty('--duration', `${duration}s`);
          activeBanner.classList.add('active');
        };
        const duration = 5;
        activeImage.style.setProperty('--duration', `${duration}s`);
        activeImage.classList.add('active');
        applyBanner(duration);
      }
    }
    // -----------------------------------------------
  } else {
    // PC
    initSwiper({ initialSlide: window.moviePosition || 0 });
  }
  // 2025-05-04: SP初期バナーにduration適用
  if (window.storeeelItems.isMobile) {
    const allSlides = document.querySelectorAll('.storeeel-swiper-group-wrapper .swiper-slide');
    const initialSlide = allSlides[window.moviePosition || 0];
    const headerBanners = initialSlide?.querySelectorAll('.storeeel-movie-select_banner');
    const video = initialSlide?.querySelector('video');
    const image = initialSlide?.querySelector('img');

    if (video && headerBanners?.[0]) {
      video.addEventListener('loadedmetadata', () => {
        const duration = video.duration || 3;
        headerBanners[0].style.setProperty('--duration', `${duration}s`);
        headerBanners[0].classList.add('active');
      });
    } else if (image && headerBanners?.[0]) {
      const duration = 5;
      headerBanners[0].style.setProperty('--duration', `${duration}s`);
      headerBanners[0].classList.add('active');
    }
  }
  const swiper = getSwiperInstance();
  //  SP時、初期スライドの最初のバナーにactiveを付与
  if (window.storeeelItems.isMobile) {
    const allSlides = document.querySelectorAll('.storeeel-swiper-group-wrapper .swiper-slide');
    const initialSlide = allSlides[window.moviePosition || 0];
    const headerBanners = initialSlide?.querySelectorAll('.storeeel-movie-select_banner');
    if (headerBanners?.[0]) {
      headerBanners[0].classList.add('active');
    }
  }

  // 2025-05-03: 初期のスライド状態を外部で適用
  applySlideScaling();
  updateHeaderWidthToSlide();

  swiper.on('slideChangeTransitionStart', () => {
    applySlideScaling();
    updateHeaderWidthToSlide();
  });

  if (!window.storeeelItems.isMobile) {
    // グループ内のスライド全てにCTAボタンを追加
    const allWrappers = document.querySelectorAll('.storeeel-swiper-group-wrapper .swiper-slide .slide-media-wrapper');
    allWrappers.forEach((wrapper, index) => {
      const ctaText = contents[index]?.ctaText || '';
      wrapper.insertAdjacentHTML('beforeend', ctaButton(ctaText));
    });
  }

  // 各種共通アクション
  // activeのスライドの動画のみ再生
  activeVideoPlay();
  // 閉じるボタンをクリックしたときの処理
  closeButtonClickAction();
  // 音量ボタンをクリックしたときの処理
  volumeButtonClickAction();
  // シェアボタンをクリックしたときの処理
  sharingClickAction();
  // 全動画をプリロード(再生スピード向上のため)
  preloadVideo();
  // 動画を開いた時に一番初めに実行される関数
  playEventHandler();
  // 動画の進捗をトラッキング(レポート用)
  trackMediaProcess();
  // CTAボタンをクリックしたときの処理
  clickCtaAction();
  // 別タブ移動時の処理(まだうまくいっていない)
  visibilityChangeAction();
  if (window.storeeelItems.isMobile) {
    // スマホ専用アクション
    // 動画の停止/再生を切り替える
    mobileVideoControls();
    // 動画終了後の次の動画を自動再生する
    mobileAutoPlayNextAction();
    // スライドした時のグループ移動処理
    groupSwipeAction();
    // スライドで閉じるアクション
    closeSwipeAction();
    if (window.storeeelItems.frame === "circle") {
      // SP + circle のみタップでの移動を有効化
      changeMovieTapAction();
      // スライドのCTAボタンをクリックしたときの処理
      swipeCtaAction();
      // 初回限定アニメーション（SP + circle）
      circleOverlayAction();
    }else {
      // 初回限定アニメーション（SP + square）
      introSquareSlideAnimation();
    }
  } else {
    // PC専用アクション
    desktopArrowIconsAction();
    // 動画の終了後の次の動画を自動再生する
    setupAutoPlayNextAction();
    // PC 時は常にスライドクリックで該当スライドに移動
    slideClickNavigateAction();
    if (window.storeeelItems.frame === "circle") {
      // circle モードのみグループ移動ボタンを有効化
      groupMoveButtonAction();
    }
  }
};
